import * as React from 'react';
import { ToggleGroupItem } from '@/components/ui/toggle-group';
import { cn } from '@/lib/utils';

const toggleGroupSizeStyles = cn(
	'flex-shrink-0 font-[600] transition-all duration-200 flex items-center justify-center '+
  'text-[var(--toggle-foreground)] bg-[var(--toggle-background)] border-[3px] border-[var(--toggle-border)] '+
  'hover:text-[var(--toggle-hover-foreground)] hover:bg-[var(--toggle-hover-background)] hover:border-0 '+
  'data-[state=on]:bg-[var(--toggle-toggled-background)] data-[state=on]:text-[var(--toggle-toggled-foreground)] data-[state=on]:border-0 '+
  'disabled:text-[var(--toggle-disabled-foreground)] disabled:bg-[var(--toggle-disabled-background)] '+
  // Responsive styles
  'size-[48px] rounded-[6px] text-[14px] data-[state=on]:size-[42px] ' + // Default
  'md:size-[56px] md:rounded-[8px] md:text-[16px] md:data-[state=on]:size-[50px] ' + // md
  'lg:size-[64px] lg:rounded-[10px] lg:text-[18px] lg:data-[state=on]:size-[56px] ' + // lg and above
  // Custom size for 440px–639px
  'min-[440px]:max-[639px]:size-[64px] min-[440px]:max-[639px]:rounded-[10px] min-[440px]:max-[639px]:data-[state=on]:size-[56px] ' +
  // Responsive Outline styles for selected state
  'data-[state=on]:!outline-1 data-[state=on]:outline-offset-1 ' + // Default
  'md:data-[state=on]:!outline-2 md:data-[state=on]:outline-offset-2 ' + // md
  'lg:data-[state=on]:!outline-3 lg:data-[state=on]:outline-offset-3 ' + // lg
  'data-[state=on]:outline data-[state=on]:mx-0.5 data-[state=on]:outline-[var(--toggle-toggled-border)]'
);

export interface ToggleGroupSizeItemProps
	extends Omit<React.ComponentProps<typeof ToggleGroupItem>, 'size'> {
	displayValue: string | number; // Use displayValue to avoid conflict with ToggleGroupItem's value prop
}

const ToggleGroupSizeItem = React.forwardRef<
HTMLButtonElement,
ToggleGroupSizeItemProps
>(({ className, displayValue, ...props }, ref) => {
	return (
		<ToggleGroupItem
			className={cn(toggleGroupSizeStyles, className)}
			ref={ref}
			{...props}
		>
			{displayValue}
		</ToggleGroupItem>
	);
});

ToggleGroupSizeItem.displayName = 'ToggleGroupSizeItem';

export { ToggleGroupSizeItem };